module.exports = __webpack_public_path__ + "img/05-1中图.794a54aa.png";